import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FolderButtons from "../components/folder/FolderButtons";
import AdjuntoCard from "../components/folder/AdjuntoCard";
import FolderIcon from "../components/folder/FolderIcon";
import Breadcrumb from "../components/common/Breadcrumb";
import { FolderContext } from "../context/FolderContext";
import { MenuContext } from "../context/MenuContext";
import { notCliente } from "../utils/permisos";
import useProyecto from "../hooks/useProyecto";
import { CapacitorContext } from "../context/CapacitorContext";
import usePreciario from "../hooks/usePreciario";

const Folder = ({ size, idFolder, params = {}, filter, hideActions, hideFolderButton }) => {
  const { idProyecto, proyecto } = useProyecto();
  const {
    setButtons,
    setSelected,
    selected,
    setTitle,
    setSubtitle,
    setHandleClickTitle,
    setBack,
  } = useContext(MenuContext);
  const { idEstimacionVersion } = usePreciario();
  const { platform } = useContext(CapacitorContext);
  const {
    folder,
    getFolder,
    clearFolder,
    pushBreadcrumb,
    popBreadcrumb,
    breadcrumb,
    setBreadcrumb,
  } = useContext(FolderContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    return () => {
      setButtons(null);
      setBack(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (folder && folder.root === false) {
      setBack(() => {
        const parts = location.pathname.split("/");
        if (breadcrumb.length >= 2) {
          const previousFolder = breadcrumb[breadcrumb.length - 2];
          popBreadcrumb();
          parts[parts.length - 1] = previousFolder.idFolder;
          navigate(parts.join("/"));
        } else {
          parts.pop();
          navigate(parts.join("/"));
        }
      });
    } else {
      setBack(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder, breadcrumb]);

  useEffect(() => {
    if (selected === "supervision") setTitle("Supervisión");
    if (selected === "catalogo") setTitle("Catálogo");
    if (selected === "proyecto") setTitle("Proyecto");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  useEffect(() => {
    fetchFolder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idFolder]);

  useEffect(() => {
    if (folder !== null && proyecto !== null) {
      if (!idEstimacionVersion) {
        setSelected({ title: folder.nombre });
        if (
          notCliente(proyecto) &&
          platform !== "web" &&
          !idEstimacionVersion
        ) {
          setButtons(
            <FolderButtons
              idProyecto={idProyecto}
              fetchFolder={fetchFolder}
              hideFolderButton={hideFolderButton}
            />
          );
          setHandleClickTitle(fetchFolder);
        }
        if (folder?.root === true) {
          setSubtitle(null);
          setBreadcrumb([folder]);
        }
        if (folder?.root === false) {
          setSubtitle(folder.nombre);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder, proyecto]);

  const fetchFolder = () => {
    clearFolder();
    getFolder(idProyecto, idFolder);
  };

  const handlePushBreadcrumb = (currentFolder) => {
    if (!currentFolder.root) {
      pushBreadcrumb(currentFolder);
    }
    clearFolder();
  };

  const renderCarpetas = () => {
    if (folder && folder !== null) {
      return folder.subfolders.map((currentFolder) => (
        <FolderIcon
          folder={currentFolder}
          key={currentFolder.idFolder}
          idProyecto={idProyecto}
          editable={currentFolder.editable}
          getParentFolder={getFolder}
          handleBreadcrumb={() => handlePushBreadcrumb(currentFolder)}
        />
      ));
    }
  };

  const renderContenido = () => {
    if (folder !== null) {
      if (folder.subfolders.length === 0 && folder.adjuntos.length === 0) {
        return <p className="mt-3">Aún no hay contenido</p>;
      }

      let carpetas = renderCarpetas();
      let adjuntos = renderAdjuntos();
      let components = carpetas.concat(adjuntos);
      return components;
    }
    return <div className="spinner-border m-3"></div>;
  };

  const renderAdjuntos = () => {
    if (folder !== null) {
      if (Array.isArray(folder.adjuntos) && folder.adjuntos.length > 0) {
        let adjuntosRender = [...folder.adjuntos];
        if (typeof filter === "function") {
          adjuntosRender = adjuntosRender.filter((adjunto) => filter(adjunto));
        }
        if (adjuntosRender.length === 0) {
          return (
            <p className="mt-3" key="empty">
              Aún no hay contenido para esta búsqueda
            </p>
          );
        }
        return (
          <div key={"adjuntos-container"} className="row px-2">
            {adjuntosRender.map((adjunto) => (
              <AdjuntoCard
                size={size}
                adjunto={adjunto}
                key={adjunto.idAdjunto}
                focused={adjunto}
                idProyecto={idProyecto}
                idFolder={folder.idFolder}
                params={params}
              />
            ))}
          </div>
        );
      }
    }
  };

  const renderHeader = () => {
    if (platform === "web" || (platform !== "web" && idEstimacionVersion))
      return (
        <div className="row">
          <div className="col-12 col-md-9">
            <Breadcrumb idProyecto={idProyecto} />
          </div>
          <div className="col-12 col-md-3">
            {!hideActions && (
              <FolderButtons
                filter={filter}
                idProyecto={idProyecto}
                fetchFolder={fetchFolder}
                hideFolderButton={hideFolderButton}
              />
            )}
          </div>
        </div>
      );
  };

  return (
    <div
      className="container-fluid h-100"
      style={{ overflowY: "auto", overflowX: "hidden" }}
    >
      {renderHeader()}
      <div className="row mt-3 align-items-center">{renderContenido()}</div>
    </div>
  );
};

export default Folder;
